export default __webpack_public_path__ + "static/media/ostrich.407b102d.png";